import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthStateService } from '../services/auth-state.service';
import { AuthService } from '../services/auth.service';
import { StudioService } from '../services/studio.service';

async function canActivateWithPermission(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
  const authState = inject(AuthStateService);
  const authService = inject(AuthService);
  const router = inject(Router);
  const studios = inject(StudioService);

  if (!authState.isLoggedIn) {
    const refreshedToken = await authService.refreshToken();
    if (!refreshedToken) {
      authState.returnToPath = state.url;
      router.navigate(['/login']);
      return false;
    }
  }

  const maxRole = route.data?.['maxRole'];
  const role = authState.currentUser?.role ?? 99;
  if (typeof maxRole === 'number' && role > maxRole) {
    router.navigate(['/unauthorized']);
    return false;
  }

  const studioId = route.paramMap.get('studioId');
  if (role > 10 && studioId !== null) {
    try {
      const accessible = await studios.list();
      if (!Array.isArray(accessible) ||
          !accessible.some((studio: any) => Number(studio.id) === Number(studioId))) {
        router.navigate(['/unauthorized']);
        return false;
      }
    } catch {
      router.navigate(['/unauthorized']);
      return false;
    }
  }

  return true;
}

export const authGuard: CanActivateFn = (route, state) => canActivateWithPermission(route, state);

export const authChildGuard: CanActivateChildFn = (route, state) => canActivateWithPermission(route, state);
